// AUTO-GENERATED by scripts/generate-filters.mjs — DO NOT EDIT.
// Run `npm run spec:types` to regenerate from ../backend/openapi.json.
// Source of truth: each list route's `*ListConfig.filterable`/`sortable`/
// `searchable`, projected onto OpenAPI as `x-filterable`/`x-sortable`/
// `x-searchable` (#1407, #1639, #1642).

import type { FilterWhitelist, SearchWhitelist, SortWhitelist } from '@resource-kit/controllers';
export const CUSTOMER_FILTERS = {
  state: ['eq', 'in'],
  created_at: ['from', 'to', 'between'],
  first_name: ['eq', 'like'],
  last_name: ['eq', 'like'],
  email: ['eq', 'like'],
  phone: ['eq', 'like'],
  tags: ['eq', 'like'],
  shopify_id: ['eq', 'in'],
  orders_count: ['eq', 'from', 'to', 'between'],
  total_spent: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const ORDER_FILTERS = {
  financial_status: ['eq', 'in'],
  fulfillment_status: ['eq', 'in'],
  customer_id: ['eq'],
  name: ['eq', 'like'],
  email: ['eq', 'like'],
  currency: ['eq', 'like'],
  tags: ['eq', 'like'],
  shopify_id: ['eq', 'in'],
  delivery_date: ['eq', 'from', 'to', 'between'],
  total_price: ['from', 'to', 'between'],
  created_at: ['from', 'to', 'between'],
  processed_at: ['from', 'to', 'between'],
  cancelled_at: ['from', 'to', 'between'],
  closed_at: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const PRODUCT_FILTERS = {
  status: ['eq', 'in'],
  title: ['eq', 'like'],
  handle: ['eq', 'like'],
  vendor: ['eq', 'like'],
  product_type: ['eq', 'like'],
  tags: ['eq', 'like'],
  source: ['eq'],
  shopify_id: ['eq', 'in'],
  published_at: ['from', 'to', 'between'],
  created_at: ['from', 'to', 'between'],
  updated_at: ['from', 'to', 'between'],
  shipping_date: ['eq', 'from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const DRIVER_FILTERS = {
  name: ['eq', 'like'],
  onfleet_id: ['eq', 'in'],
  phone: ['eq', 'like'],
  email: ['eq', 'like'],
  active: ['eq'],
  created_at: ['from', 'to', 'between'],
  updated_at: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const FULFILLMENT_JOB_FILTERS = {
  status: ['eq', 'in'],
  name: ['eq', 'like'],
  shipping_date: ['eq', 'from', 'to', 'between'],
  order_id: ['eq', 'in'],
  driver_id: ['eq', 'in'],
  onfleet_task_id: ['eq', 'in'],
  onfleet_task_short_id: ['eq', 'like'],
  shopify_order_id: ['eq'],
  created_at: ['from', 'to', 'between'],
  updated_at: ['from', 'to', 'between'],
  onfleet_updated_at: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const WEBHOOK_FAILURE_FILTERS = {
  provider: ['eq'],
  error_kind: ['eq'],
  topic: ['eq'],
  resolved: ['eq'],
  received_at: ['from', 'to', 'between'],
  created_at: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const WEBHOOK_EVENT_FILTERS = {
  provider: ['eq'],
  topic: ['eq'],
  status: ['eq'],
} as const satisfies FilterWhitelist;

export const RESOURCE_AUDIT_FILTERS = {
  resource_type: ['eq'],
  resource_id: ['eq'],
  actor_id: ['eq'],
  action: ['eq'],
  source: ['eq'],
  created_at: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const AUDIT_LOG_FILTERS = {
  actor: ['eq'],
  action: ['eq'],
  created_at: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const REVIEW_QUEUE_FILTERS = {
  kind: ['eq', 'in'],
  created_at: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const PURCHASE_ORDER_FILTERS = {
  status: ['eq', 'in'],
  supplier_id: ['eq', 'like'],
  created_at: ['from', 'to', 'between'],
  updated_at: ['from', 'to', 'between'],
} as const satisfies FilterWhitelist;

export const CATALOG_INGREDIENT_FILTERS = {
} as const satisfies FilterWhitelist;

export const CATALOG_SUPPLIER_FILTERS = {
} as const satisfies FilterWhitelist;

export const CATALOG_DISH_FILTERS = {
} as const satisfies FilterWhitelist;

export const CATALOG_COMBO_FILTERS = {
} as const satisfies FilterWhitelist;

export const CUSTOMER_SORTS = ['created_at', 'orders_count', 'total_spent', 'state', 'first_name', 'last_name', 'email', 'phone', 'tags', 'shopify_id'] as const satisfies SortWhitelist;

export const ORDER_SORTS = ['created_at', 'processed_at', 'delivery_date', 'total_price', 'financial_status', 'fulfillment_status', 'customer_id', 'cancelled_at', 'name', 'email', 'currency', 'tags', 'shopify_id', 'closed_at'] as const satisfies SortWhitelist;

export const PRODUCT_SORTS = ['status', 'title', 'handle', 'vendor', 'product_type', 'tags', 'source', 'shopify_id', 'published_at', 'shipping_date', 'created_at', 'updated_at'] as const satisfies SortWhitelist;

export const DRIVER_SORTS = ['name', 'onfleet_id', 'phone', 'email', 'active', 'created_at', 'updated_at'] as const satisfies SortWhitelist;

export const FULFILLMENT_JOB_SORTS = ['order_id', 'name', 'status', 'shipping_date', 'driver_id', 'onfleet_task_id', 'onfleet_task_short_id', 'created_at', 'updated_at', 'onfleet_updated_at'] as const satisfies SortWhitelist;

export const WEBHOOK_FAILURE_SORTS = ['created_at', 'received_at', 'updated_at', 'resolved_at', 'error_kind', 'provider', 'topic'] as const satisfies SortWhitelist;

export const WEBHOOK_EVENT_SORTS = ['received_at', 'completed_at', 'provider_emitted_at', 'status', 'provider', 'topic'] as const satisfies SortWhitelist;

export const RESOURCE_AUDIT_SORTS = ['created_at'] as const satisfies SortWhitelist;

export const AUDIT_LOG_SORTS = ['created_at'] as const satisfies SortWhitelist;

export const REVIEW_QUEUE_SORTS = ['kind', 'created_at'] as const satisfies SortWhitelist;

export const PURCHASE_ORDER_SORTS = ['status', 'supplier_id', 'created_at', 'updated_at'] as const satisfies SortWhitelist;

export const CATALOG_INGREDIENT_SORTS = [] as const satisfies SortWhitelist;

export const CATALOG_SUPPLIER_SORTS = [] as const satisfies SortWhitelist;

export const CATALOG_DISH_SORTS = [] as const satisfies SortWhitelist;

export const CATALOG_COMBO_SORTS = [] as const satisfies SortWhitelist;

export const CUSTOMER_SEARCH = ['email', 'first_name', 'last_name', 'phone'] as const satisfies SearchWhitelist;

export const ORDER_SEARCH = ['name', 'email', 'order_number'] as const satisfies SearchWhitelist;

export const PRODUCT_SEARCH = ['title'] as const satisfies SearchWhitelist;

export const DRIVER_SEARCH = [] as const satisfies SearchWhitelist;

export const FULFILLMENT_JOB_SEARCH = ['name', 'onfleet_task_short_id', 'operator_note', 'order_note', 'line_items_json', 'customer_name', 'customer_phone'] as const satisfies SearchWhitelist;

export const WEBHOOK_FAILURE_SEARCH = [] as const satisfies SearchWhitelist;

export const WEBHOOK_EVENT_SEARCH = [] as const satisfies SearchWhitelist;

export const RESOURCE_AUDIT_SEARCH = [] as const satisfies SearchWhitelist;

export const AUDIT_LOG_SEARCH = [] as const satisfies SearchWhitelist;

export const REVIEW_QUEUE_SEARCH = [] as const satisfies SearchWhitelist;

export const PURCHASE_ORDER_SEARCH = [] as const satisfies SearchWhitelist;

export const CATALOG_INGREDIENT_SEARCH = ['name'] as const satisfies SearchWhitelist;

export const CATALOG_SUPPLIER_SEARCH = ['name'] as const satisfies SearchWhitelist;

export const CATALOG_DISH_SEARCH = ['name'] as const satisfies SearchWhitelist;

export const CATALOG_COMBO_SEARCH = ['name', 'code'] as const satisfies SearchWhitelist;
